<template>
  <a-modal
    :open="true"
    title="请选择"
    width="80%"
    :destroyOnClose="true"
    @ok="onOk"
  >
    <div
      class="table-modal"
      :style="{ height: `${height}px` }"
    >
      <div class="header">
        当前选择：
        <a-tag
          v-for="item in innerValue"
          :closable="true"
          :key="item.value"
          @close="handlerClose(item)"
        >
          {{ item.label }}
        </a-tag>
      </div>
      <component
        :is="asyncTable"
        :config="tableConfig"
        :initSelectValue="initSelectValue"
        :initValueKey="valueKey"
        @selectChange="handlerSelectChange"
      ></component>
    </div>
  </a-modal>
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent, onMounted, onUnmounted, ref } from 'vue';
const emit = defineEmits(['ok']);
const props = defineProps({
  tableConfig: {
    type: Object,
    required: true,
  },
  isMultiple: {
    type: Boolean,
    default: true,
  },
  value: {
    type: Object as () => any,
    default: () => null,
  },
  labelKey: {
    type: String,
    default: 'name',
  },
  labelKeyList: {
    type: Array,
    default: () => [],
  },
  labelKeyType: {
    type: Number,
    default: 0,
  },
  labelSpace: {
    type: String,
    default: '',
  },
  valueKey: {
    type: String,
    default: 'id',
  },
});
const asyncTable = defineAsyncComponent(
  () => import('liyu-pc-base/components/tablePro/tablePro.vue'),
);
const height = ref(500);
const innerValue = ref([]);

const resize = () => {
  height.value = window.innerHeight - 300;
};
const initSelectValue = computed(() => {
  if (innerValue.value) {
    return innerValue.value.map(item => {
      return item.value;
    });
  } else {
    return [];
  }
});
onMounted(() => {
  resize();
  window.addEventListener('resize', resize);
  innerValue.value = props.value;
});
onUnmounted(() => {
  window.removeEventListener('resize', resize);
});
const handlerClose = item => {
  innerValue.value = innerValue.value.filter(i => i.value !== item.value);
};
const getLable = item => {
  let label;
  if (props.labelKeyList && props.labelKeyList.length > 0 && props?.labelKeyType !== 1) {
    const labelList = [];
    for (const key of props.labelKeyList) {
      labelList.push(item[key as string]);
    }
    label = labelList.join(props.labelSpace);
  } else {
    label = item[props.labelKey];
  }
  return label;
};
const handlerSelectChange = (selectdRecord, unSelectdRecord) => {
  if (props.isMultiple) {
    const tmpValue = [...(innerValue.value || [])];
    for (const item of unSelectdRecord) {
      const value = item[props.valueKey];
      if (!tmpValue.some(i => i.value === value)) {
        continue;
      }
      tmpValue.splice(
        tmpValue.findIndex(i => i.value === value),
        1,
      );
    }
    for (const item of selectdRecord) {
      const value = item[props.valueKey];
      const label = getLable(item);
      if (!tmpValue.some(i => i.value === value)) {
        tmpValue.push({
          value: value,
          label: label,
        });
      }
    }

    innerValue.value = tmpValue;
  } else {
    if (selectdRecord?.length > 0) {
      const item = selectdRecord[0];
      const value = item[props.valueKey];
      const label = getLable(item);
      innerValue.value = [
        {
          value: value,
          label: label,
        },
      ];
    } else {
      innerValue.value = [];
    }
  }
};
const onOk = () => {
  emit('ok', innerValue.value);
};
</script>
<style scoped lang="less">
.table-modal {
  display: flex;
  flex-direction: column;
  gap: 8px;
  .header {
    padding: 4px;
  }
}
</style>
